import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReinvestmentFacade } from "./reinvestment.facades";


@NgModule({
    imports: [
        CommonModule
    ],
    providers: [ReinvestmentFacade]
})
export class ReinvestmentStoreModule { }
